
import React from 'react';
import './ScrollButtons.scss';

const ScrollButtons: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  return (
    <div className='scroll-buttons'>
      <button
        type='button'
        onClick={scrollToTop}
        title='Lên đầu trang'
        aria-label='Lên đầu trang'
      >
        ↑
      </button>

      <button
        type='button'
        onClick={scrollToBottom}
        title='Xuống cuối trang'
        aria-label='Xuống cuối trang'
      >
        ↓
      </button>
    </div>
  );
};

export default ScrollButtons;
